//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import l from 'lang';
export default {
  props: {
    'message': {
      'type': String,
      'required': true
    },
    'level': {
      'type': String,
      'required': false,
      validator: val => ['error', 'warning', 'success'].includes(val)
    },
    'closable': {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      l,
      show: true
    };
  },
  computed: {
    icon() {
      if (this.$props.level === 'success') {
        return '$vuetify.icons.check';
      }
      if (this.$props.level === 'warning') {
        return '$vuetify.icons.infotip_stylized';
      }
      return '$vuetify.icons.exclamation';
    },
    icon_classes() {
      const classes = {
        'my-auto white--text': this.$props.level !== 'warning'
      };
      classes[this.icon_color] = true;
      return classes;
    },
    icon_color() {
      if (this.$props.level === 'success') {
        return 'info';
      }
      if (this.level === 'warning') {
        return 'warning--text text--darken1';
      }
      return this.$props.level;
    }
  },
  watch: {
    show: {
      // eslint-disable-next-line object-shorthand
      handler: function (val) {
        if (!val) {
          this.$emit('closed');
        }
      }
    }
  }
};